import React from "react";
import { Form, Select } from "antd";
import { VISIBILITY, VISIBILITY_OPTIONS } from "../../constants/app-constants";
import { FORM_LANG, formText } from "../../constants/form-i18n";

const { Option } = Select;

/** NMU-444: option wording follows the dialog's active tab language. */
const OPTION_TEXT_KEY = {
  [VISIBILITY.INTERNAL]: "visibilityInternal",
  [VISIBILITY.EXTERNAL]: "visibilityExternal",
  [VISIBILITY.PUBLIC]: "visibilityPublic",
};

/**
 * Reusable content-distribution (visibility) selector.
 * Backend field name: `visibility` (String enum INTERNAL | EXTERNAL | PUBLIC, default PUBLIC).
 * Use inside an antd Form. The parent Form should seed initialValues={{ visibility: 'PUBLIC' }}
 * (or setFieldsValue on edit) so the control defaults to PUBLIC.
 *
 * @param lang NMU-444: "th" | "en", the language of the dialog's active tab. An
 *   explicit `label` still wins, so a caller that passes its own wording keeps it.
 */
const VisibilityFormItem = ({
  label,
  name = "visibility",
  className,
  lang = FORM_LANG.TH,
}) => {
  const t = formText(lang);

  return (
    <Form.Item label={label || t("visibility")} name={name} className={className}>
      <Select>
        {VISIBILITY_OPTIONS.map((item) => (
          <Option key={item.value} value={item.value}>
            {OPTION_TEXT_KEY[item.value] ? t(OPTION_TEXT_KEY[item.value]) : item.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default VisibilityFormItem;
